jQuery.feature_import("js-view-calendar",
  () => require("./index.js"),
  mod => mod.feature_js_view_calendar
);